import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { DayCalendarSkeleton } from '@mui/x-date-pickers/DayCalendarSkeleton';
import { useEffect, useRef, useState } from 'react';
import { badge } from './EventCalendar.Badge';
import { CalendarHeader } from './EventCalandar.Header';
import updateLocale from 'dayjs/plugin/updateLocale';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { dateIndex } from 'utilities/utility.calendar';

dayjs.extend(updateLocale);

function getRandomNumber(min, max) {
  return Math.round(Math.random() * (max - min) + min);
}

export const EventCalendar = ({ eventData, selectedEvent, setSelectedEvent }) => {
  
  const [isLoading, setIsLoading]               = useState(false);
  const [highlightedDays, setHighlightedDays]   = useState([]);

  const fetchHighlightedDays = (ED) => {
    const daysToHighlight = ED.map((ed) => new dayjs(ed.FromDate))
    setHighlightedDays(daysToHighlight);
    setSelectedEvent(daysToHighlight[0])
    setIsLoading(false);
  };

    // Replace "en" with the name of the locale you want to update.
  dayjs.updateLocale('en', {
      // Sunday = 0, Monday = 1.
    weekStart: 1,
  });

  useEffect(() => {
    fetchHighlightedDays(eventData);
  }, []);

  return (
    <LocalizationProvider dateAdapter = {AdapterDayjs}>
      <DateCalendar
        value    = {selectedEvent}
        onChange = {(newValue) => {
          if(dateIndex(highlightedDays, newValue) >= 0) {
            setSelectedEvent(newValue)
          }
      }}
        loading               = {isLoading}
        renderLoading         = {() => <DayCalendarSkeleton />}
        disableHighlightToday = {true}
        slots                 = {{
          day           : badge,
          calendarHeader: CalendarHeader
        }}
        slotProps={{
          day: {
            highlightedDays,
            selectedEvent
          },
        }}
        dayOfWeekFormatter = {(date) => getDayNames('en', date)}
        sx                 = {{ background: '#fff', borderRadius: '24px', border: '1px solid #D1D1D1', margin: 'unset', width: '300px', height: '271px', 
          ".MuiDayCalendar-header": {
          padding: '24px 24px',
          span: {
            height: '13px',
            fontSize: '10px',

          }
        },
        ".MuiDayCalendar-monthContainer": {
          display: 'flex',
          flexDirection: 'column',
          gap: '8px'
        },
        ".MuiDayCalendar-weekContainer": {
          gap: '14px',
            "span": {
              width: '24px',
              height: '24px',
            },
            "button": {
              width: '24px',
              height: '24px',
              margin: 0,
              zIndex: 10
            }
          }
       }}
      />
    </LocalizationProvider>
  );
}

const getDayNames = (locale = 'en', date) => {
      // Return the first 3 characters of the day name
    return dayjs(date).format('ddd')
  };
  